export default __webpack_public_path__ + "static/media/Temperature.5a34cb25.svg";